import dynamic from "next/dynamic";

export const ContentSideImages = dynamic(() => import("./component"));
